export { Subtitle2Stronger, subtitle2StrongerClassNames } from './components/presets/Subtitle2Stronger/index';
